import { TextInput } from '@mgmresorts/mgm-ui';
import React, { useContext } from 'react';

import { useContent } from '../../../../hooks/useContent';
import { MaxLengths } from '../../../../utils/constants';
import { MlifeActivationContext } from '../../MlifeActivationContext';

export function EmailInput() {
  const { activationRequest } = useContext(MlifeActivationContext);
  const { getContentByPath } = useContent();

  return (
    <TextInput
      variant='default'
      label={getContentByPath('mlifeActivation.accountSetupSection.fields.email.title')}
      id='email'
      disabled
      icon='lock'
      className={`identity__field`}
      testId='email'
      value={activationRequest?.login ?? ''}
      maxLength={MaxLengths.Email}
      autoComplete='email'
      type='email'
    />
  );
}

EmailInput.displayName = 'EmailInputField';
